// @ts-check
import { defineConfig } from '../utils';

export function picking() {
  return defineConfig({
    properties: {
      'Picking.LecturaCajas.LecturaContinuaCodigosBarras': {
        defaultValue: false,
      },
      'Picking.LecturaCajas.LecturaContinuaCodigosBarrasManual': {
        defaultValue: false,
      },
      'Picking.LecturaCajas.UtilizarFlash': {
        defaultValue: true,
      },
      'Picking.LecturaCajas.OrientacionCamaraLecturaCodigos': {
        /** @type {'landscape' | 'portrait'} */
        defaultValue: 'portrait',
      },
      'Picking.LecturaCajas.LecturaEnTraspaso': {
        defaultValue: false,
      },
      'Picking.ReplanificarCantidadPaleTraspasadoOReprocesadoAutomaticamente': {
        defaultValue: false,
      },
    },
  });
}
